"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var Grid_1 = require("@mui/material/Grid");
var React = require("react");
var react_router_1 = require("react-router");
var button_component_1 = require("../../../common/buttons/button_component");
var iconButton_component_1 = require("../../../common/buttons/iconButton_component");
var route_path_1 = require("../../../constants/route_path");
var drop_down_component_1 = require("../../../common/drop_down/drop_down_component");
var Region_Selector_1 = require("./Region_Selector");
var react_hot_toast_1 = require("react-hot-toast");
var user_logistics_api_1 = require("./user_logistics_api");
var react_redux_1 = require("react-redux");
var array_helpers_1 = require("../../../utils/array_helpers");
var formik_1 = require("formik");
var AssignRegion = function () {
    var state = (0, react_router_1.useLocation)().state;
    var nav = (0, react_router_1.useNavigate)();
    var id = (0, react_router_1.useParams)().id;
    var regionsinitialValues = {
        company: ''
    };
    var _a = React.useState({}), selectedStates = _a[0], setSelectedStates = _a[1];
    var _b = React.useState({}), selectedCities = _b[0], setSelectedCities = _b[1];
    var _c = React.useState({}), selectedLabs = _c[0], setSelectedLabs = _c[1];
    var _d = React.useState([]), allCities = _d[0], setAllCities = _d[1];
    var _e = React.useState([]), allLabs = _e[0], setAllLabs = _e[1];
    var _f = React.useState([]), allStates = _f[0], setAllStates = _f[1];
    var _g = React.useState([]), cities = _g[0], setCities = _g[1];
    var _h = React.useState([]), labs = _h[0], setLabs = _h[1];
    var _j = React.useState([]), statesData = _j[0], setStatesData = _j[1];
    var _k = React.useState(), allCitiesData = _k[0], setAllCitiesData = _k[1];
    var _l = React.useState(), allLabsData = _l[0], setAllLabsData = _l[1];
    var _m = React.useState(), allResponseStates = _m[0], setAllResponseStates = _m[1];
    var _o = React.useState(), allResponseCities = _o[0], setAllResponseCities = _o[1];
    var _p = React.useState(), allResponseLabs = _p[0], setAllResponseLabs = _p[1];
    var _q = React.useState({}), editResponse = _q[0], setEditResponse = _q[1];
    var _r = React.useState(), selectedCompanies = _r[0], setSelectedCompanies = _r[1];
    var _s = React.useState(regionsinitialValues), initialValues = _s[0], setinitialValues = _s[1];
    var _t = React.useState(state), navigationData = _t[0], setNavigationData = _t[1];
    var companiesList = (0, react_redux_1.useSelector)(function (store) { return store.appConfigList.company_names; });
    var navigateToUserList = function () {
        return nav("/".concat(route_path_1.default.PATHS.User_Logistics));
    };
    var fetchEditDetails = function (allLabs, allCities, allStates, setEditDetails) {
        var response = navigationData.data;
        var companies = [];
        var selectedCompanies = navigationData.selectedCompanies;
        if (response.length < 1) {
            var responseData_1 = [];
            companiesList.forEach(function (companyData) {
                var responseObj = {
                    company_id: companyData.value,
                    company_name: companyData.label,
                    states: [],
                    all_state_access: true
                };
                responseData_1.push(responseObj);
            });
            response['access_details'] = responseData_1;
        }
        response.access_details.forEach(function (regionDetails) {
            var obj = {
                id: regionDetails.company_id,
                label: regionDetails.company_name,
                value: regionDetails.company_id
            };
            companies.push(obj);
        });
        setEditResponse(response);
        setSelectedCompanies(selectedCompanies);
        if (setEditDetails) {
            setinitialValues({
                company: selectedCompanies[0]
            });
            var accessData = response.access_details.find(function (accessDetails) { return accessDetails.company_name === selectedCompanies[0].label; });
            setEditData(accessData, allCities, allLabs, allStates);
        }
    };
    var getStateCityByLab = function (cityName, cityData) {
        for (var state_1 in cityData) {
            var city = cityData[state_1].find(function (city) { return city.name === cityName; });
            if (city) {
                return {
                    state: state_1,
                    cityDetails: city
                };
            }
        }
        return null;
    };
    var getStateByCity = function (cityId, states, cities) {
        var stateData = {};
        var _loop_1 = function (state_2) {
            var cityData = cities[state_2].find(function (city) { return city.id === cityId; });
            if (cityData === null || cityData === void 0 ? void 0 : cityData.name) {
                states['All States'].filter(function (stateDetails) {
                    if (stateDetails.name === state_2) {
                        stateData = stateDetails;
                    }
                });
            }
        };
        for (var state_2 in cities) {
            _loop_1(state_2);
        }
        return stateData;
    };
    var getCityNameById = function (cityId, citiesData) {
        var cityData;
        for (var city in citiesData) {
            var cityDetails = citiesData[city].find(function (city) { return city.id === cityId; });
            if (cityDetails) {
                cityData = cityDetails;
            }
        }
        return cityData;
    };
    var getCityName = function (cityId, citiesData) {
        for (var _i = 0, citiesData_1 = citiesData; _i < citiesData_1.length; _i++) {
            var state_3 = citiesData_1[_i];
            var city = state_3.regions.find(function (region) { return region.id === cityId; });
            if (city) {
                return city;
            }
        }
        return null;
    };
    var getStateName = function (stateId, statesData) {
        var stateName;
        statesData.forEach(function (stateInfo) {
            if (stateInfo.id == stateId) {
                stateName = stateInfo.name;
            }
        });
        return stateName;
    };
    var getCompanyId = function (companyName) {
        var companyId;
        companiesList.forEach(function (companyInfo) {
            if (companyInfo.label == companyName) {
                companyId = companyInfo.id;
            }
        });
        return companyId;
    };
    var getFilteredPayload = function (labs, cities, states) {
        var updatedLabs = {};
        Object.keys(labs).map(function (key) {
            if (labs[key] && labs[key].length > 0) {
                updatedLabs[key] = labs[key];
            }
        });
        var payloadCities = [];
        Object.keys(updatedLabs).forEach(function (key) {
            var citiesObj = {};
            var cityData = getStateCityByLab(key, cities);
            if (cityData != null && cityData != undefined) {
                var selectedCityLabs = updatedLabs[cityData.cityDetails.name].map(function (labDetails) {
                    return labDetails.id;
                });
                citiesObj['city_id'] = cityData.cityDetails.id;
                citiesObj['labs'] = selectedCityLabs;
                payloadCities.push(citiesObj);
            }
        });
        var statesPayload = [];
        payloadCities.map(function (citiesData) {
            var stateDetails = getStateByCity(citiesData.city_id, states, cities);
            var existingState = statesPayload.find(function (stateData) { return stateData.state_id === stateDetails.id; });
            if (existingState) {
                existingState.cities.push(citiesData);
            }
            else {
                var obj = {
                    state_id: stateDetails.id,
                    country_id: 1,
                    cities: [citiesData]
                };
                statesPayload.push(obj);
            }
        });
        statesPayload.forEach(function (stateData) {
            var stateName = states['All States'].filter(function (stateDetails) { return stateDetails.id === stateData.state_id; });
            var selectedCity = allCities.filter(function (cityDetails) { return cityDetails.name === stateName[0].name; });
            stateData.cities.forEach(function (citiesData) {
                var cityName = getCityNameById(citiesData.city_id, cities);
                var selectedLab = allLabs.filter(function (labDetails) { return labDetails.name === cityName.name; });
                if (selectedLab[0].regions.length === citiesData.labs.length) {
                    citiesData['all_lab_access'] = true;
                    citiesData['labs'] = [];
                }
                else {
                    citiesData['all_lab_access'] = false;
                }
            });
            var hasLabAccessFalse = stateData.cities.some(function (citiesData) { return citiesData.all_lab_access === false; });
            if (selectedCity[0].regions.length === stateData.cities.length && !hasLabAccessFalse) {
                stateData['all_city_access'] = true;
                stateData['cities'] = [];
            }
            else {
                stateData['all_city_access'] = false;
            }
        });
        statesPayload.forEach(function (item, index) {
            var existingStateIndex = statesPayload.findIndex(function (state) { return state.state_id === item.state_id; });
            if (existingStateIndex !== -1 && existingStateIndex !== index) {
                statesPayload[existingStateIndex].cities = __spreadArray(__spreadArray([], statesPayload[existingStateIndex].cities, true), item.cities, true);
                statesPayload.splice(index, 1);
            }
        });
        return statesPayload;
    };
    var checkIsLabExist = function (existingData, labName, cityId) {
        if (existingData.length > 0) {
            for (var _i = 0, existingData_1 = existingData; _i < existingData_1.length; _i++) {
                var state_4 = existingData_1[_i];
                for (var _a = 0, _b = state_4.cities; _a < _b.length; _a++) {
                    var city = _b[_a];
                    if (city.city_id === cityId) {
                        if (city.labs.length > 0) {
                            if (city.labs.includes(labName)) {
                                return true;
                            }
                        }
                        else {
                            return true;
                        }
                    }
                }
            }
        }
        return false;
    };
    var compareSubmitResponse = function (payload, values) {
        var _a;
        var existingResponseData = editResponse.access_details.filter(function (companyDetails) { return companyDetails.company_name === values.label; });
        var removedStatesData = [];
        if ((_a = existingResponseData[0]) === null || _a === void 0 ? void 0 : _a.states) {
            existingResponseData[0].states.forEach(function (stateDetails) {
                var statesObj = {};
                var citiesData = [];
                if (stateDetails.cities.length > 0) {
                    stateDetails.cities.forEach(function (cityDetails) {
                        var citiesObj = {};
                        var removedLabData = [];
                        if (cityDetails.labs.length > 0) {
                            cityDetails.labs.forEach(function (LabDetails) {
                                var isExist = checkIsLabExist(payload.access_details.added, LabDetails.lab_code, cityDetails.city_id);
                                if (!isExist) {
                                    removedLabData.push(LabDetails.lab_code);
                                }
                            });
                        }
                        else {
                            var cityName = getCityNameById(cityDetails.city_id, selectedCities);
                            if (!cityName) {
                                var stateName_1 = getStateName(cityDetails.state_id, allStates[0].regions);
                                var labsNotInSelectedLabs = allLabs.find(function (labDetails) { return labDetails.name.trim() === cityDetails.city_name.trim() && labDetails.state === stateName_1; });
                                if (labsNotInSelectedLabs) {
                                    labsNotInSelectedLabs.regions.forEach(function (labDetails) {
                                        removedLabData.push(labDetails.id);
                                    });
                                }
                            }
                        }
                        if (removedLabData.length > 0) {
                            citiesObj['city_id'] = cityDetails.city_id;
                            citiesObj['labs'] = removedLabData;
                            var cityInfo_1 = getCityName(cityDetails.city_id, allCities);
                            var selectedAllLabData = allLabs.find(function (labData) { return labData.name === cityInfo_1.name && labData.state === cityInfo_1.state; });
                            if (selectedAllLabData) {
                                if (removedLabData.length === selectedAllLabData.regions.length) {
                                    citiesObj['all_lab_access'] = true;
                                    citiesObj['labs'] = [];
                                }
                                else {
                                    citiesObj['all_lab_access'] = false;
                                }
                            }
                            citiesData.push(citiesObj);
                        }
                    });
                }
                else {
                    var stateName_2 = allStates[0].regions.find(function (stateData) { return stateData.id === stateDetails.state_id; });
                    var selectedStateCities = selectedCities[stateName_2.name];
                    if ((selectedStateCities === null || selectedStateCities === void 0 ? void 0 : selectedStateCities.length) > 0) {
                        selectedStateCities.forEach(function (cityDetails) {
                            var citiesObj = {};
                            var removedLabData = [];
                            var selectedCityLabs = selectedLabs[cityDetails.name.trim()];
                            var selectedCityAllLabs = allLabs.find(function (labDetails) { return labDetails.name === cityDetails.name.trim() && labDetails.state === cityDetails.state; });
                            if (selectedCityAllLabs && (selectedCityAllLabs.regions.length !== (selectedCityLabs === null || selectedCityLabs === void 0 ? void 0 : selectedCityLabs.length))) {
                                selectedCityAllLabs.regions.forEach(function (item1) {
                                    if (!selectedCityLabs.some(function (item2) { return item2.name === item1.name; })) {
                                        removedLabData.push(item1.id);
                                    }
                                });
                                citiesObj['city_id'] = cityDetails.id;
                                var selectedAllLabData = allLabs.find(function (labData) { return labData.name.trim() === cityDetails.name.trim() && labData.state === cityDetails.state; });
                                if (removedLabData.length === selectedAllLabData.regions.length) {
                                    citiesObj['all_lab_access'] = true;
                                    citiesObj['labs'] = [];
                                }
                                else {
                                    citiesObj['all_lab_access'] = false;
                                    citiesObj['labs'] = removedLabData;
                                }
                                citiesData.push(citiesObj);
                            }
                        });
                    }
                    else {
                        var citiesNotInSelectedCities = allCities.find(function (cityInfo) { return cityInfo.name === stateName_2.name; });
                        citiesNotInSelectedCities === null || citiesNotInSelectedCities === void 0 ? void 0 : citiesNotInSelectedCities.regions.forEach(function (cityData) {
                            var citiesObj = {};
                            var removedLabData = [];
                            var labsNotInSelectedLabs = allLabs.find(function (labData) { return labData.name.trim() === cityData.name.trim() && labData.state === cityData.state; });
                            if (labsNotInSelectedLabs) {
                                labsNotInSelectedLabs === null || labsNotInSelectedLabs === void 0 ? void 0 : labsNotInSelectedLabs.regions.forEach(function (labData) {
                                    removedLabData.push(labData.id);
                                });
                                citiesObj['city_id'] = cityData.id;
                                var selectedAllLabData = allLabs.find(function (labData) { return labData.name.trim() === cityData.name.trim() && labData.state === cityData.state; });
                                if (removedLabData.length === selectedAllLabData.regions.length) {
                                    citiesObj['all_lab_access'] = true;
                                    citiesObj['labs'] = [];
                                }
                                else {
                                    citiesObj['all_lab_access'] = false;
                                    citiesObj['labs'] = removedLabData;
                                }
                                citiesData.push(citiesObj);
                            }
                        });
                    }
                }
                if (citiesData.length > 0) {
                    statesObj['state_id'] = stateDetails.state_id;
                    statesObj['country_id'] = stateDetails.country_id;
                    var stateName_3 = allStates[0].regions.find(function (stateInfo) { return stateInfo.id === stateDetails.state_id; });
                    var selectedAllCityData = allCities.find(function (cityInfo) { return cityInfo.name === stateName_3.name; });
                    var hasLabAccessFalse = citiesData.some(function (citiesData) { return citiesData.all_lab_access === false; });
                    if (citiesData.length === selectedAllCityData.regions.length && !hasLabAccessFalse) {
                        statesObj['all_city_access'] = true;
                        statesObj['cities'] = [];
                    }
                    else {
                        statesObj['all_city_access'] = false;
                        statesObj['cities'] = citiesData;
                    }
                    removedStatesData.push(statesObj);
                }
            });
        }
        return {
            removedData: removedStatesData,
            addedData: payload.access_details.added
        };
    };
    var formSubmitHandler = function (values) {
        var statesPayload = getFilteredPayload(selectedLabs, selectedCities, selectedStates);
        var payload = {
            user_id: id ? id : navigationData.userId,
            company: values.label,
            all_company_access: navigationData.all_company_access
        };
        if (statesPayload.length === allStates[0].regions.length) {
            payload['all_state_access'] = true,
                payload['access_details'] = {
                    added: []
                };
        }
        else {
            payload['all_state_access'] = false,
                payload['access_details'] = {
                    added: statesPayload,
                    removed: []
                };
        }
        if (id) {
            var data = compareSubmitResponse(payload, values);
            payload['access_details']['added'] = data.addedData;
            payload['access_details']['removed'] = data.removedData;
        }
        (0, user_logistics_api_1.createUpdateRegion)(payload)
            .then(function (response) {
            var _a;
            if (response.statusCode === 200) {
                react_hot_toast_1.default.success("Region successfully created for the ".concat(values.label, " company"), { duration: 3000 });
                var companyName = getCompanyId(payload.company);
                var updatedResponse_1 = {
                    user_id: payload.user_id,
                    all_access: payload.all_company_access,
                    access_details: []
                };
                var obj_1 = {
                    user_id: payload.user_id,
                    company_id: companyName,
                    company_name: payload.company,
                    states: [],
                    all_state_access: payload.all_state_access
                };
                if (!payload.all_state_access) {
                    payload.access_details.added.forEach(function (regions) {
                        var stateName = getStateName(regions.state_id, allStates[0].regions);
                        var regionsObj = {
                            state_id: regions.state_id,
                            country_id: regions.country_id,
                            state_name: stateName,
                            cities: [],
                            all_city_access: regions.all_city_access
                        };
                        if (!regions.all_city_access) {
                            regions.cities.forEach(function (citiesData) {
                                var cityName = getCityName(citiesData.city_id, allCities);
                                var citiesObj = {
                                    city_id: citiesData.city_id,
                                    city_name: cityName.name,
                                    state_id: regions.state_id,
                                    labs: [],
                                    all_lab_access: citiesData.all_lab_access
                                };
                                if (!citiesData.all_lab_access) {
                                    citiesData.labs.forEach(function (labsData) {
                                        var labData = {
                                            lab_code: labsData
                                        };
                                        citiesObj.labs.push(labData);
                                    });
                                }
                                regionsObj.cities.push(citiesObj);
                            });
                        }
                        obj_1.states.push(regionsObj);
                    });
                }
                updatedResponse_1.access_details.push(obj_1);
                if (editResponse && ((_a = editResponse === null || editResponse === void 0 ? void 0 : editResponse.access_details) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    setEditResponse(function (prevState) { return (__assign(__assign({}, prevState), { access_details: prevState.access_details.map(function (region) {
                            return region.company_name === payload.company ? __assign(__assign({}, region), { states: updatedResponse_1.access_details[0].states }) : region;
                        }) })); });
                }
                else {
                    setEditResponse(updatedResponse_1);
                }
            }
            else {
                react_hot_toast_1.default.error(response.message);
            }
        })
            .catch(function (error) {
            react_hot_toast_1.default.error(error.message);
        });
    };
    var convertCitiesData = function (data) {
        var obj = {};
        data.forEach(function (citiesDetails) {
            obj[citiesDetails.name] = citiesDetails.regions;
        });
        return obj;
    };
    var setEditData = function (data, allCities, allLabs, allStates) {
        if (data) {
            if (data.all_state_access) {
                var obj = {
                    'All States': allStates[0].regions
                };
                setSelectedStates(obj);
                var convertedCities = convertCitiesData(allCities);
                setSelectedCities(convertedCities);
                var convertedLabs = convertCitiesData(allLabs);
                setSelectedLabs(convertedLabs);
            }
            else {
                var responseStates_1 = [];
                data.states.forEach(function (stateDetails) {
                    var stateData = allStates[0].regions.find(function (stateInfo) { return stateDetails.state_id === stateInfo.id; });
                    responseStates_1.push(stateData);
                    if (stateDetails.all_city_access) {
                        var citiesData_2 = allCities.find(function (cityInfo) { return cityInfo.name === stateData.name; });
                        setSelectedCities(function (prevCities) {
                            var _a;
                            return (__assign(__assign({}, prevCities), (_a = {}, _a[stateData.name] = citiesData_2.regions, _a)));
                        });
                        var obj_2 = {};
                        citiesData_2.regions.forEach(function (cityInfo) {
                            allLabs.forEach(function (labDetails) {
                                if (labDetails.name === cityInfo.name && labDetails.state === cityInfo.state) {
                                    obj_2[cityInfo.name] = labDetails.regions;
                                }
                            });
                        });
                        setSelectedLabs(function (prevCities) { return (__assign(__assign({}, prevCities), obj_2)); });
                    }
                    else {
                        var responseCities_1 = [];
                        stateDetails.cities.forEach(function (cityDetails) {
                            var cityData = allCities.find(function (cityInfo) { return cityInfo.name === stateData.name; });
                            var responseCityDetails = cityData.regions.find(function (cityInfo) { return cityInfo.id === cityDetails.city_id; });
                            if (responseCityDetails) {
                                responseCities_1.push(responseCityDetails);
                                if (cityDetails.all_lab_access) {
                                    var labData_1 = allLabs.find(function (labinfo) { return labinfo.name === responseCityDetails.name && labinfo.state === responseCityDetails.state; });
                                    setSelectedLabs(function (prevLabs) {
                                        var _a;
                                        return (__assign(__assign({}, prevLabs), (_a = {}, _a[responseCityDetails.name] = labData_1 === null || labData_1 === void 0 ? void 0 : labData_1.regions, _a)));
                                    });
                                }
                                else {
                                    var responseLabs_1 = [];
                                    cityDetails.labs.forEach(function (labDetails) {
                                        var labData = allLabs.find(function (labinfo) { return labinfo.name === responseCityDetails.name && labinfo.state === responseCityDetails.state; });
                                        var responseLabDetails = labData.regions.find(function (labinfo) { return labinfo.id === labDetails.lab_code; });
                                        responseLabs_1.push(responseLabDetails);
                                    });
                                    setSelectedLabs(function (prevCities) {
                                        var _a;
                                        return (__assign(__assign({}, prevCities), (_a = {}, _a[responseCityDetails.name] = responseLabs_1, _a)));
                                    });
                                }
                            }
                        });
                        setSelectedCities(function (prevCities) {
                            var _a;
                            return (__assign(__assign({}, prevCities), (_a = {}, _a[stateData.name] = responseCities_1, _a)));
                        });
                    }
                });
                setSelectedStates({
                    'All States': responseStates_1
                });
            }
        }
    };
    var doesLabExistInCity = function (labsData, cityName, stateName) {
        var isExist = labsData.some(function (labDetails) { return labDetails.name === cityName && labDetails.state === stateName; });
        return isExist;
    };
    var checkIsAllCitiesExist = function (citiesData, labsData) {
        var labContainingCities = [];
        citiesData.forEach(function (citiesInfo) {
            labsData.forEach(function (labInfo) {
                if (labInfo.name === citiesInfo.name && labInfo.state === citiesInfo.state) {
                    labContainingCities.push(citiesInfo);
                }
            });
        });
        return labContainingCities;
    };
    var updateAllStateCityAndLabs = function (citiesData, statesData, labsData, company, setEditDetails) {
        if (citiesData[company] && labsData[company]) {
            var convertedCitiesdata_1 = (0, array_helpers_1.convertCityResponse)(citiesData[company]);
            var convertedLabResponse_1 = (0, array_helpers_1.convertLabListResponse)(labsData[company]);
            var convertedStatesData = (0, array_helpers_1.convertStateResponse)(statesData);
            var updatedStates = convertedStatesData.map(function (stateInfo) {
                var updatedRegions = stateInfo.regions.filter(function (stateDetails) {
                    var isExist = convertedLabResponse_1.some(function (labDetails) { return labDetails.state === stateDetails.name; });
                    var isExistInCityData = false;
                    convertedCitiesdata_1.forEach(function (citiesData) {
                        if (citiesData.name === stateDetails.name) {
                            isExistInCityData = true;
                            var isStateExistInLabs = checkIsAllCitiesExist(citiesData.regions, convertedLabResponse_1);
                            if (isStateExistInLabs.length < 1) {
                                isExist = false;
                            }
                        }
                    });
                    return isExist && isExistInCityData;
                });
                return __assign(__assign({}, stateInfo), { regions: updatedRegions });
            });
            var updatedCities = convertedCitiesdata_1.map(function (statesData) {
                var updatedRegions = statesData.regions.filter(function (cityDetails) {
                    return doesLabExistInCity(convertedLabResponse_1, cityDetails.name, cityDetails.state);
                });
                if (updatedRegions.length > 0) {
                    return __assign(__assign({}, statesData), { regions: updatedRegions });
                }
                return null;
            }).filter(function (item) { return item !== null; });
            if (updatedCities.length > 0) {
                setAllCitiesData(updatedCities);
                setAllCities(convertedCitiesdata_1);
            }
            if (convertedLabResponse_1.length > 0) {
                setAllLabsData(convertedLabResponse_1);
                setAllLabs(convertedLabResponse_1);
            }
            if (updatedStates.length > 0) {
                setStatesData(updatedStates);
                setAllStates(convertedStatesData);
            }
            if (id) {
                fetchEditDetails(convertedLabResponse_1, updatedCities, updatedStates, setEditDetails);
            }
            return {
                updatedStates: updatedStates,
                updatedCities: updatedCities,
                updatedLabs: convertedLabResponse_1
            };
        }
        else {
            setStatesData([]);
            setAllStates([]);
            setAllLabsData([]);
            setAllLabs([]);
            setAllCitiesData([]);
            setAllCities([]);
        }
    };
    var fetchStateCityAndLabs = function () { return __awaiter(void 0, void 0, void 0, function () {
        var statesPayload, stateRes, convertedStates, payload, cityRes, convertedCities, labsPayload, labListRes, convertedLabs, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    statesPayload = { all_states: true };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, , 6]);
                    return [4, (0, user_logistics_api_1.getAllStatesData)(statesPayload)];
                case 2:
                    stateRes = _a.sent();
                    setAllResponseStates(stateRes[0]);
                    convertedStates = stateRes[0];
                    payload = { state_id: convertedStates.map(function (state) { return state.id; }), all_cities: true };
                    return [4, (0, user_logistics_api_1.getCitiesData)(payload)];
                case 3:
                    cityRes = _a.sent();
                    convertedCities = (0, array_helpers_1.convertedCityandLabResponse)(cityRes.cities);
                    setAllResponseCities(convertedCities);
                    labsPayload = { all_labs: true };
                    return [4, (0, user_logistics_api_1.getAllLabsData)(labsPayload)];
                case 4:
                    labListRes = _a.sent();
                    convertedLabs = (0, array_helpers_1.convertedCityandLabResponse)(labListRes);
                    setAllResponseLabs(convertedLabs);
                    updateAllStateCityAndLabs(convertedCities, convertedStates, convertedLabs, navigationData.selectedCompanies[0].label, true);
                    if (!id) {
                        setinitialValues({
                            company: navigationData.selectedCompanies[0]
                        });
                    }
                    return [3, 6];
                case 5:
                    err_1 = _a.sent();
                    console.error('Error fetching data:', err_1);
                    return [3, 6];
                case 6: return [2];
            }
        });
    }); };
    var companyOnchangehandler = function (val, setFieldValue) {
        setSelectedCities({});
        setSelectedStates({});
        setSelectedLabs({});
        setLabs([]);
        setCities([]);
        setinitialValues({
            company: val
        });
        setFieldValue('company', val);
        var updatedData = updateAllStateCityAndLabs(allResponseCities, allResponseStates, allResponseLabs, val.label, false);
        if (id) {
            var accessData = editResponse.access_details.find(function (accessDetails) { return accessDetails.company_name === val.label; });
            if (updatedData) {
                setEditData(accessData, updatedData.updatedCities, updatedData.updatedLabs, updatedData.updatedStates);
            }
        }
        else {
            if (editResponse) {
                var accessData = editResponse.access_details.find(function (accessDetails) { return accessDetails.company_name === val.label; });
                if (updatedData) {
                    setEditData(accessData, updatedData.updatedCities, updatedData.updatedLabs, updatedData.updatedStates);
                }
            }
        }
    };
    var isValidObjectWithNonEmptyArray = function (obj) {
        return (Object.keys(obj).length > 0 &&
            Object.values(obj).some(function (arr) { return Array.isArray(arr) && arr.length > 0; }));
    };
    React.useEffect(function () {
        fetchStateCityAndLabs();
    }, []);
    React.useEffect(function () {
        if (state) {
            setNavigationData(function (prevData) { return (__assign(__assign({}, prevData), { data: editResponse })); });
        }
    }, [state, editResponse]);
    var renderForm = function () {
        return (React.createElement(formik_1.Formik, { initialValues: initialValues, onSubmit: function () { }, enableReinitialize: true }, function (_a) {
            var values = _a.values, setFieldValue = _a.setFieldValue;
            return (React.createElement(formik_1.Form, { className: "input-fileds-wrapper" },
                React.createElement("div", { className: "tool-bar-wrapper border-bottom no-filter-toolbar" },
                    React.createElement("div", { className: "page-heaidng heading-return-wrapper" },
                        React.createElement(iconButton_component_1.default, { className: "btn-retun", icon: 'icon-left-arrow', onClick: navigateToUserList }),
                        React.createElement("h2", null, !id
                            ? 'Assign Regions'
                            : 'Manage Regions')),
                    React.createElement("div", { className: "page-control-wrapper" },
                        React.createElement(button_component_1.default, { type: "button", buttonName: "Cancel", color: "yellow-outline", onClickHandler: navigateToUserList }),
                        React.createElement(button_component_1.default, { buttonName: "Save", color: "yellow", onClickHandler: function () {
                                if (values.company === '') {
                                    react_hot_toast_1.default.error('Please select a company', { duration: 3000 });
                                }
                                else if (!isValidObjectWithNonEmptyArray(selectedStates)) {
                                    react_hot_toast_1.default.error('Please select at least one state', { duration: 3000 });
                                }
                                else if (!isValidObjectWithNonEmptyArray(selectedCities)) {
                                    react_hot_toast_1.default.error('Please select at least one city', { duration: 3000 });
                                }
                                else if (!isValidObjectWithNonEmptyArray(selectedLabs)) {
                                    react_hot_toast_1.default.error('Please select at least one lab', { duration: 3000 });
                                }
                                else {
                                    formSubmitHandler(values.company);
                                }
                            } }))),
                React.createElement("div", { className: "scrollable-content" },
                    React.createElement("div", { className: "add-slotform" },
                        React.createElement("div", { className: "input-fileds-wrapper" },
                            React.createElement(Grid_1.default, { container: true, columns: { xs: 12, lg: 12 }, columnSpacing: 3 },
                                React.createElement(Grid_1.default, { item: true, xs: 3, lg: 3.5 },
                                    React.createElement(drop_down_component_1.default, { name: "company", value: values.company, dropDownList: id ? selectedCompanies : navigationData ? navigationData.selectedCompanies : [], placeholder: 'Company', label: 'Company', required: true, onChange: function (val) { return companyOnchangehandler(val, setFieldValue); } }))))),
                    React.createElement(Region_Selector_1.default, { setSelectedStates: setSelectedStates, setSelectedCities: setSelectedCities, setSelectedLabs: setSelectedLabs, selectedStates: selectedStates, selectedCities: selectedCities, selectedLabs: selectedLabs, company: values.company, setLabs: setLabs, setCities: setCities, cities: cities, labs: labs, statesData: statesData, allCitiesData: allCitiesData, allLabsData: allLabsData }))));
        }));
    };
    return React.createElement("div", { className: "create-role-wrapper" }, renderForm());
};
exports.default = AssignRegion;
